import { ConversationsPubSub } from '../client/ConversationsPubSub';
export const buildConversationsPubSubFromVendor = (vendor, clientOptions) => {
  return new ConversationsPubSub(vendor, clientOptions);
};